import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth, db } from "../firebase";
import { createUserWithEmailAndPassword, signOut } from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import {
    Box,
    Button,
    Container,
    TextField,
    Typography,
    Paper,
    Alert
} from "@mui/material";

function SignupPage() {
    const [orgId, setOrgId] = useState("");
    const [orgName, setOrgName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [message, setMessage] = useState("");
    const navigate = useNavigate();

    const handleSignup = async () => {
        setMessage("");

        if (!email.includes("@") || password.length < 6) {
            setMessage("❌ Please enter a valid email and password (min 6 characters).");
            return;
        }

        try {
            const userCred = await createUserWithEmailAndPassword(auth, email, password);
            const uid = userCred.user.uid;

            console.log("User created successfully with UID:", uid);

            // Add a small delay to ensure auth state propagates
            await new Promise(resolve => setTimeout(resolve, 1000));

            // Now create the Firestore documents
            await setDoc(doc(db, "organizations", orgId), {
                name: orgName,
                createdAt: new Date()
            });

            console.log("Organization document created");

            await setDoc(doc(db, "organizations", orgId, "users", uid), {
                email,
                role: "admin",
                name: "Admin"
            });

            console.log("User document created in organization");

            await setDoc(doc(db, "userOrgs", uid), {
                email,
                orgId
            });

            console.log("userOrgs document created");

            setMessage("✅ Organization and admin account created successfully. Redirecting to login...");

            // Wait briefly to show success then redirect
            setTimeout(async () => {
                await signOut(auth);
                navigate("/login");
            }, 2000);

        } catch (err) {
            console.error("🔥 Sign-up error:", err.code, err.message);
            setMessage(`❌ ${err.message}`);
        }
    };

    return (
        <Container maxWidth="sm">
            <Paper sx={{ mt: 5, p: 4 }}>
                <Typography variant="h6" gutterBottom>
                    ✨ Sign Up as Admin & Create Organization
                </Typography>
                {message && <Alert severity="info">{message}</Alert>}
                <TextField
                    label="Organization ID"
                    fullWidth
                    margin="normal"
                    value={orgId}
                    onChange={(e) => setOrgId(e.target.value)}
                />
                <TextField
                    label="Organization Name"
                    fullWidth
                    margin="normal"
                    value={orgName}
                    onChange={(e) => setOrgName(e.target.value)}
                />
                <TextField
                    label="Admin Email"
                    fullWidth
                    margin="normal"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />
                <TextField
                    label="Password"
                    type="password"
                    fullWidth
                    margin="normal"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                />
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSignup}
                    sx={{ mt: 2 }}
                >
                    Create Account
                </Button>

                <Box sx={{ mt: 2, textAlign: "center" }}>
                    <Typography variant="body2">
                        Already have an account?{' '}
                        <Button variant="text" size="small" onClick={() => navigate("/login")}>Back to Login</Button>
                    </Typography>
                </Box>
            </Paper>
        </Container>
    );
}

export default SignupPage;